import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Team Evaluation Results", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Survey Details:", -1)

import { DateTime } from "luxon";
import { TANDEM_DATE_SHORT } from "@/core";
import TeamEvaluationTeamTab from "@/components/TeamEvaluationTeamTab.vue";
import TeamEvaluationClassResults from "@/components/TeamEvaluationClassResults.vue";
import TabbedPageLayout from "@/layouts/TabbedPageLayout.vue";

interface Props {
  cohortId: number;
  cohortSurveyId: number;
  cohortName: string;
  surveyName: string;
  publishDateIsoString: string;
  dueDateIsoString: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TeamEvaluationResults',
  props: {
    cohortId: {},
    cohortSurveyId: {},
    cohortName: {},
    surveyName: {},
    publishDateIsoString: {},
    dueDateIsoString: {}
  },
  setup(__props: any) {



const tabs = [
  { title: "Detailed View", key: "team" },
  { title: "Class Results", key: "class" },
];

const formatDate = (isoDateString: string) =>
  DateTime.fromISO(isoDateString).toFormat(TANDEM_DATE_SHORT);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TabbedPageLayout, {
    tabs: tabs,
    "content-container-class": "team-eval-results"
  }, {
    "general-block": _withCtx(() => [
      _hoisted_1,
      _createElementVNode("h2", null, [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.surveyName) + " - " + _toDisplayString(formatDate(_ctx.publishDateIsoString)) + "–" + _toDisplayString(formatDate(_ctx.dueDateIsoString)), 1)
      ])
    ]),
    team: _withCtx(() => [
      _createVNode(TeamEvaluationTeamTab, {
        "cohort-id": _ctx.cohortId,
        "cohort-survey-id": _ctx.cohortSurveyId
      }, null, 8, ["cohort-id", "cohort-survey-id"])
    ]),
    class: _withCtx(() => [
      _createVNode(TeamEvaluationClassResults, {
        "cohort-id": _ctx.cohortId,
        "cohort-survey-id": _ctx.cohortSurveyId
      }, null, 8, ["cohort-id", "cohort-survey-id"])
    ]),
    _: 1
  }))
}
}

})